export const PRODUCT_NAMES = {
  INVOICES: 'processing',
  PAYMENT_LINKS: 'processing',
  MASS_PAYMENTS: 'payroll',
  SWAP: 'swap',
}
